// extracted by mini-css-extract-plugin
export default {"container":"panel_container__RNaEC","header":"panel_header__CmwTO"};